import { useModal } from "@/hooks/modals/useModal";
import { RdRawMaterialRequisitionForm } from "../components/RdRawMaterialRequisitionForm/RdRawMaterialRequisitionForm";
import { RldReferenceProductRequisitionForm } from "../components/RldReferenceProductRequisitionForm/RldReferenceProductRequisitionForm";
import { type PurchaseRequestType, PurchaseRequestTypeMap } from "@/constants";
import { HighValuePurchaseRequisitionForm } from "../components/HighValuePurchaseRequisitionForm/HighValuePurchaseRequisitionForm";
import { LowValuePurchaseRequisitionForm } from "../components/LowValuePurchaseRequisitionForm/LowValuePurchaseRequisitionForm";
import { usePurchaseRequestDetail } from "./usePurchaseRequest";

const FormRegistry = {
  [PurchaseRequestTypeMap.RdRawMaterialRequisition]:
    RdRawMaterialRequisitionForm,
  [PurchaseRequestTypeMap.RldReferenceProductRequisition]:
    RldReferenceProductRequisitionForm,
  [PurchaseRequestTypeMap.HighValuePurchaseRequisition]:
    HighValuePurchaseRequisitionForm,
  [PurchaseRequestTypeMap.LowValuePurchaseRequisition]:
    LowValuePurchaseRequisitionForm,
};

export function usePurchaseRequestForm() {
  const { props } = useModal("PURCHASE_REQUEST");
  const { type, recordId } = props;
  let actualType = type;
  const detail = usePurchaseRequestDetail(recordId);

  if (!type && detail) {
    actualType = detail?.formType as PurchaseRequestType;
  }

  if (!actualType) return null;
  console.log("🚀 ~ usePurchaseRequestForm ~ actualType:", actualType);
  const matchedForm = FormRegistry[actualType as keyof typeof FormRegistry];

  return matchedForm;
}
